import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from './Icon';
import DeliveryLocationForm from './DeliveryLocationForm';

export default ({ active, location, handleLocationRemove, setSelectedDeliveryLocation, selectedVerbiage, setEditIndex, editing, index, handleLocationUpdated }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    function handleMenuClick(event) {
        setAnchorEl(event.currentTarget);
    }
    if (editing) {
        return (
            <DeliveryLocationForm 
                initialValue={location}
                handleCancelClick={() => {
                    setEditIndex(null);
                    setAnchorEl(null);
                }}
                handleSubmitSuccess={(value) => {
                    handleLocationUpdated(value, location)
                }}
            />
        )
    }
    return (
        <>
            <div className={`flex-action-container${active ? ' active' : ''}`} key={location}>
                {active && <div className='default-banner'>{selectedVerbiage}</div>}
                <button className='btn content' onClick={() => setSelectedDeliveryLocation(location)}>
                    <div className='icon-container small'>
                        <Icon iconName="mapMarker" width={22} />
                    </div>
                    <div className='info'>{location}</div>
                </button>
                <button className='btn action-btn' onClick={handleMenuClick} title="Edit this delivery location">
                    <Icon iconName="ellipsis" width={16} />
                </button>
            </div>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem onClick={() => {
                    setEditIndex(index);
                }}>Edit location</MenuItem>
                <MenuItem onClick={() => handleLocationRemove(location)}>Delete location</MenuItem>
            </Menu>
        </>
    )
}